import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 19.25A9.25 9.25 0 0 0 19.25 10 9.25 9.25 0 0 0 10 .75 9.25 9.25 0 0 0 .75 10 9.25 9.25 0 0 0 10 19.25m-5-10a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }